import React from "react";
import { Container } from "react-bootstrap";

const TopBarOnWebPage = () => {
  return <Container fluid className="object-top-bar" />;
};

export default TopBarOnWebPage;
